import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import legalService from "@/services/modules/legalService";
const DepositCryptoDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/DepositCryptoDetail/index"
  );
const DepositRialDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/DepositRialDetail/index"
  );
const WithdrawCryptoDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/WithdrawCryptoDetail/index"
  );
const WithdrawRialDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/WithdrawRialDetail/index"
  );
const ExchangeDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/ExchangeDetail/index"
  );
const OfflinePaymentDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/OfflinePaymentDetail/index"
  );
const TransferDetail = () =>
  import(
    "@/components/TransactionsPage/TransactionDetail/TransferDetail/index"
  );
export default {
  name: "transaction-detail",
  components: {
    DepositCryptoDetail,
    DepositRialDetail,
    WithdrawCryptoDetail,
    WithdrawRialDetail,
    ExchangeDetail,
    OfflinePaymentDetail,
    TransferDetail
  },
  props: [],
  data() {
    return {
      drawer: true,
      showDetail: false,
      orderDetails: null
    };
  },
  computed: {
    ...mapGetters({
      transactionsDetail: types.transactions.getters.GET_TRANSACTIONS_DETAIL,
      getTransactionOrderData:
        types.transactions.getters.GET_TRANSACTIONS_ORDER,
      getOfflineTransaction: types.transactions.getters.GET_TRANSACTIONS_OFFLINE
    }),
    setTransactionDetail() {
      if (Object.entries(this.transactionsDetail).length > 0) {
        return this.transactionsDetail;
      }
    },
    transactionDetailData() {
      if (Object.entries(this.setTransactionDetail).length > 0) {
        if (this.setTransactionDetail.transaction_type === "offlinePayment") {
          if (Object.entries(this.getOfflineTransaction).length > 0) {
            return this.getOfflineTransaction.data.find(elem => {
              if (elem.id === this.setTransactionDetail.reference_number) {
                return elem;
              }
            });
          }
        } else if (Object.entries(this.getTransactionOrderData).length > 0) {
          return this.getTransactionOrderData.data.find(elem => {
            if (
              elem.reference_number ===
              this.setTransactionDetail.reference_number
            ) {
              return elem;
            }
          });
        }
      }
    }
  },
  methods: {
    ...mapActions({
      transactionDetailAction:
        types.transactions.actions.ACTION_TRANSACTIONS_DETAIL
    }),
    transactionsDrawerFunc() {
      this.transactionDetailAction({
        transaction_type: "",
        drawer: false,
        reference_number: ""
      });
    }
  },
  watch: {
    transactionsDetail(newVal) {
      if (newVal.drawer && this.$cookies.get("CA_ID")) {
        legalService.orderDetails(newVal.reference_number).then(res => {
          console.log(res.data.data);
          this.orderDetails = res.data.data;
        });
      }
    }
  }
};
